import { render } from "./Reactars.vue?vue&type=template&id=19112294&ts=true"
import script from "./Reactars.vue?vue&type=script&lang=ts"
export * from "./Reactars.vue?vue&type=script&lang=ts"

import "./Reactars.vue?vue&type=style&index=0&id=19112294&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__